<script lang="ts" setup>
import { InformationItems } from '@/components/ui/types'
import _flatten from 'lodash-es/flatten'

const { value } = defineProps<{
  value: InformationItems
}>()

const hasAnyValue = computed(
  () => !!_flatten(Object.values(value).map((items) => items.map(item => item.text))).length,
)
</script>

<template>
  <div
    v-if="hasAnyValue"
    class="d-flex flex-column flex-sm-row flex-wrap ga-6 ga-sm-10"
  >
    <template
      v-for="(items, label) in value"
      :key="label"
    >
      <div
        v-if="items && items.length"
        class="d-flex flex-column ga-2"
      >
        <div
          class="text-subtitle-3 font-weight-bold text-gray-900"
          v-text="label"
        />
        <div class="d-flex flex-column align-start ga-2">
          <div
            v-for="(item, index) in items"
            :key="`${label}-${index}`"
          >
            <v-chip
              variant="outlined"
              :text="item.text"
            />
          </div>
        </div>
      </div>
    </template>
    <slot />
  </div>
</template>
